import { SabisButton2Component } from 'sabis-components2';
import { Component, OnInit } from '@angular/core';
import { AppAuthService } from '../../core/auth/app-auth.service';

@Component({
  selector: 'sca-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  imports: [SabisButton2Component]
})
export class AccessDeniedComponent implements OnInit {
  public summaryMessage: string = '';

  constructor(private _auth: AppAuthService) { }

  ngOnInit(): void {
    this._auth.getUsername().subscribe(r => {
      this.summaryMessage = `User ${r} is not allowed to access SABIS® Careers Admin`;
    });
  }

  public onLogoutClick(): void {
    this._auth.logout().subscribe(_ => { });
  }
}
